import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinetaxibookingmumbai() {



    const cardData = {




keyword: "Online Taxi Booking Mumbai",

headingDescription: "Shreesha Tours & Travels offers quick, secure, and hassle-free online taxi booking in Mumbai for local travel, airport transfers, corporate transportation, outstation journeys, railway station pickups, sightseeing tours, and long-distance travel across Maharashtra and India. We provide one-way cabs, round-trip taxi services, hourly rental packages, chauffeur-driven vehicles, and customized travel solutions for families, business travelers, tourists, students, and corporate clients. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement and budget. With instant online booking, doorstep pickup anywhere in Mumbai, experienced drivers, transparent pricing, secure payment options, and 24/7 customer support, Shreesha Tours & Travels ensures a smooth, safe, and comfortable travel experience. Whether you need an airport taxi, corporate cab, hotel transfer, wedding transportation, family vacation vehicle, pilgrimage cab, or outstation taxi, our online booking service makes reserving your ride simple, convenient, and reliable with guaranteed customer satisfaction.",

topPlaces: [
  {
    title: "Lonavala",
    description: "Lonavala is one of the most popular hill stations near Mumbai, famous for Tiger Point, Bhushi Dam, Rajmachi Fort, lush green valleys, waterfalls, and pleasant weather. It is a preferred destination for weekend trips and family vacations."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station known for Venna Lake, Arthur's Seat, Elephant's Head Point, strawberry farms, and breathtaking viewpoints. It is ideal for couples, families, and nature lovers."
  },
  {
    title: "Panchgani",
    description: "Panchgani attracts tourists with its scenic Table Land, Sydney Point, Parsi Point, Mapro Garden, and pleasant climate. It is one of the best weekend getaway destinations from Mumbai."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, home to the sacred Shri Sai Baba Samadhi Mandir. Thousands of devotees travel from Mumbai every day for darshan and spiritual experiences."
  },
  {
    title: "Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, Sula Vineyards, and the Godavari River. It is a perfect destination for religious tours, wine tourism, and family vacations."
  },
  {
    title: "Goa",
    description: "Goa is India's most popular beach destination, known for beautiful beaches, water sports, Portuguese churches, vibrant nightlife, forts, and seafood. It is one of the most booked outstation cab routes from Mumbai."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is renowned for the Mahalakshmi Temple, Rankala Lake, Panhala Fort, traditional cuisine, and rich Maratha heritage. It is an excellent destination for religious and historical tourism."
  },
  {
    title: "Ahmedabad",
    description: "Ahmedabad is Gujarat's largest city, famous for Sabarmati Ashram, Adalaj Stepwell, Kankaria Lake, and rich cultural heritage. It is a popular destination for business and leisure travelers."
  },
  {
    title: "Indore",
    description: "Indore is known for Rajwada Palace, Khajrana Ganesh Temple, Sarafa Night Market, Lal Bagh Palace, and nearby Ujjain and Omkareshwar. It is a preferred destination for business and religious travel."
  },
  {
    title: "Bangalore",
    description: "Bangalore is India's leading IT hub, famous for Lalbagh Botanical Garden, Cubbon Park, Bangalore Palace, ISKCON Temple, and vibrant shopping and dining destinations. It is a popular long-distance cab route from Mumbai."
  }
],



"services": [
  {
    "name": "Online Taxi Booking Mumbai",
    "description": "Book Online Taxi Booking Mumbai for quick, safe, and hassle-free travel with instant confirmation, professional chauffeurs, and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, Kia Carens, SUVs, and Tempo Travellers for airport transfers, local rides, corporate travel, sightseeing, family trips, and outstation journeys. Enjoy transparent pricing, doorstep pickup, flexible one way and round trip options, and 24x7 customer support for a smooth travel experience across Mumbai and beyond."
  },
  {
    "name": "Mumbai Online Cab Booking",
    "description": "Choose Mumbai Online Cab Booking for convenient reservations with affordable fares, experienced drivers, and clean vehicles. Easily book cabs for airport pickup and drop, business meetings, local city travel, weekend getaways, and long-distance tours with reliable service and instant booking confirmation."
  },
  {
    "name": "Mumbai Taxi Booking Online",
    "description": "Reserve Mumbai Taxi Booking Online with reliable chauffeur-driven cars, transparent fares, and multiple vehicle options. Enjoy comfortable transportation for family holidays, corporate travel, sightseeing, airport transfers, and outstation trips with safe and punctual service."
  },
  {
    "name": "Book Taxi Online Mumbai",
    "description": "Book Taxi Online Mumbai with easy online reservations, secure booking process, and comfortable AC vehicles. Select the perfect cab for personal travel, business trips, airport transportation, and family vacations with professional drivers and flexible travel schedules."
  },
  {
    "name": "Mumbai Cab Booking Online",
    "description": "Complete Mumbai Cab Booking Online for dependable travel with instant confirmation, well-maintained vehicles, and courteous chauffeurs. Choose from Sedan, Ertiga, Innova Crysta, SUVs, and premium cabs for every travel requirement across Mumbai and nearby destinations."
  },
  {
    "name": "Online Cab Service Mumbai",
    "description": "Hire Online Cab Service Mumbai for reliable city and outstation transportation with experienced drivers, affordable pricing, and comfortable vehicles. Enjoy seamless travel for local rides, business meetings, airport transfers, family tours, and interstate journeys."
  },
  {
    "name": "Mumbai Airport Taxi Booking Online",
    "description": "Book Mumbai Airport Taxi Booking Online for timely airport pickup and drop services with flight tracking, professional chauffeurs, and comfortable AC vehicles. Experience stress-free airport transfers from all Mumbai airport terminals to your destination."
  },
  {
    "name": "Mumbai Outstation Cab Booking Online",
    "description": "Reserve Mumbai Outstation Cab Booking Online for long-distance travel with reliable drivers, clean vehicles, and competitive fares. Travel comfortably to destinations across Maharashtra, Goa, Gujarat, Karnataka, and other states with one way and round trip options."
  },
  {
    "name": "Mumbai One Way Taxi Booking",
    "description": "Choose Mumbai One Way Taxi Booking for affordable single-trip travel without paying unnecessary return charges. Enjoy fixed pricing, comfortable vehicles, doorstep pickup, and experienced chauffeurs for safe and convenient transportation."
  },
  {
    "name": "Mumbai Round Trip Taxi Booking",
    "description": "Book Mumbai Round Trip Taxi Booking for convenient return journeys with flexible travel schedules, transparent pricing, and premium vehicles. Perfect for family vacations, business meetings, sightseeing tours, and weekend getaways."
  },
  {
    "name": "Mumbai Car Rental Booking Online",
    "description": "Choose Mumbai Car Rental Booking Online for chauffeur-driven vehicles with flexible rental packages and professional drivers. Ideal for corporate travel, weddings, family events, airport transfers, city tours, and outstation journeys."
  },
  {
    "name": "Mumbai Private Taxi Booking",
    "description": "Reserve Mumbai Private Taxi Booking for personalized travel with dedicated vehicles, experienced chauffeurs, and complete privacy. Travel comfortably for business, leisure, family functions, and long-distance trips with reliable transportation."
  },
  {
    "name": "Mumbai Corporate Cab Booking",
    "description": "Book Mumbai Corporate Cab Booking for executive travel with punctual drivers, premium vehicles, and professional service. Ideal for office transportation, client meetings, airport transfers, conferences, and business travel requirements."
  },
  {
    "name": "Mumbai 24x7 Online Taxi Service",
    "description": "Choose Mumbai 24x7 Online Taxi Service for round-the-clock cab availability with instant booking, reliable chauffeurs, and well-maintained AC vehicles. Whether you need an early morning airport transfer, late-night pickup, local travel, or outstation transportation, enjoy safe, comfortable, and dependable taxi services anytime."
  },
  {
    "name": "Fast Taxi Booking Mumbai",
    "description": "Experience Fast Taxi Booking Mumbai with quick confirmations, prompt pickups, experienced drivers, and multiple vehicle choices. Get reliable transportation for airport transfers, local rides, corporate travel, family trips, sightseeing, and outstation journeys with affordable pricing and excellent customer support."
  }
],
"tableData": [
  ["Online Taxi Booking Mumbai", "Mumbai Online Cab Booking"],
  ["Mumbai Taxi Booking Online", "Book Taxi Online Mumbai"],
  ["Mumbai Cab Booking Online", "Online Cab Service Mumbai"],
  ["Mumbai Airport Taxi Booking Online", "Mumbai Outstation Cab Booking Online"],
  ["Mumbai One Way Taxi Booking", "Mumbai Round Trip Taxi Booking"],
  ["Mumbai Car Rental Booking Online", "Mumbai Private Taxi Booking"],
  ["Mumbai Corporate Cab Booking", "Mumbai 24x7 Online Taxi Service"],
  ["Fast Taxi Booking Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Fast & Convenient Online Taxi Booking in Mumbai",
    WhyChoosedescription: "Book your ride in just a few simple steps with Shreesha Tours & Travels. Our online taxi booking service in Mumbai makes it easy to reserve reliable cabs for local travel, airport transfers, outstation trips, and business journeys."
  },
  {
    WhyChooseheading: "Instant Booking Support with Quick Confirmation",
    WhyChoosedescription: "Share your travel details online and receive prompt assistance, vehicle availability, fare information, and booking confirmation without lengthy procedures."
  },
  {
    WhyChooseheading: "Wide Range of Cars for Every Journey",
    WhyChoosedescription: "Choose from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses for solo travellers, families, and corporate groups."
  },
  {
    WhyChooseheading: "Book Local, Airport & Outstation Cabs Anytime",
    WhyChoosedescription: "Reserve taxis for Mumbai city travel, airport pickups, railway station transfers, hotel transfers, business meetings, sightseeing tours, and long-distance destinations across India."
  },
  {
    WhyChooseheading: "Flexible Travel Plans That Match Your Schedule",
    WhyChoosedescription: "Select hourly rental cabs, one-way taxis, round trips, full-day packages, or customized travel itineraries according to your convenience."
  },
  {
    WhyChooseheading: "Professional Drivers & Well-Maintained Vehicles",
    WhyChoosedescription: "Travel with experienced chauffeurs in clean, air-conditioned vehicles that are regularly inspected to ensure a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Suitable for Personal, Corporate & Group Travel",
    WhyChoosedescription: "Our online booking service is ideal for individual travellers, business executives, tourists, wedding guests, families, and group tours throughout the year."
  },
  {
    WhyChooseheading: "Reliable Online Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Enjoy transparent pricing, responsive customer support, and dependable transportation whenever you need an online taxi booking in Mumbai."
  }
]

};

const faqData = [
  {
    question: "How can I complete an online taxi booking in Mumbai?",
    answer: "Simply share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive booking confirmation from our team."
  },
  {
    question: "Can I reserve a taxi online for airport transfers?",
    answer: "Yes, online booking is available for Mumbai Airport pickups, drop-offs, and scheduled airport transfers."
  },
  {
    question: "Which vehicles can I book online?",
    answer: "You can book Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses."
  },
  {
    question: "Is online taxi booking available for outstation travel?",
    answer: "Yes, you can book one-way and round-trip outstation taxis from Mumbai to destinations across Maharashtra and other Indian states."
  },
  {
    question: "Can I book a cab online for corporate travel?",
    answer: "Yes, business travellers and companies can reserve taxis online for meetings, airport transfers, conferences, and employee transportation."
  },
  {
    question: "Can I schedule my taxi in advance?",
    answer: "Yes, advance bookings are accepted so your preferred vehicle is reserved for your selected date and time."
  },
  {
    question: "Do you offer online booking for Tempo Travellers?",
    answer: "Yes, Tempo Travellers and larger vehicles can also be reserved online for family trips, weddings, and group tours."
  },
  {
    question: "Will I receive fare details before confirming my booking?",
    answer: "Yes, complete fare information is shared before your booking is finalized so you can travel with confidence."
  },
  {
    question: "Is online booking available throughout the year?",
    answer: "Yes, our online taxi booking service operates year-round, subject to vehicle availability."
  },
  {
    question: "Why choose Shreesha Tours & Travels for online taxi booking in Mumbai?",
    answer: "We provide quick booking assistance, professional drivers, comfortable vehicles, transparent pricing, and reliable service for every journey."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harshit Mehta",
    feedback: "Booking my Mumbai airport cab online with Shreesha Tours & Travels was quick and simple. The confirmation was immediate, and the driver arrived exactly on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aishwarya Nair",
    feedback: "I reserved an online taxi for an outstation family trip. The vehicle was clean, the booking process was smooth, and the entire journey was comfortable from start to finish.",
    rating: 5
  }
];


















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Taxi Booking Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/online-taxi-booking-mumbai.webp",
  "description":
    "Book Online Taxi Booking Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We provide instant online cab booking with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for airport transfers, city rides, corporate travel, family trips, and intercity journeys across Maharashtra and India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/online-taxi-booking-mumbai"
  }
};






    return (
        <div>

<Helmet>
  <title>Online Taxi Booking Mumbai | Instant Cab Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Online Taxi Booking Mumbai with Shreesha Travels for quick and reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with instant confirmation and 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Online Taxi Booking Mumbai, Mumbai Online Cab Booking, Mumbai Taxi Booking Online, Book Taxi Online Mumbai, Mumbai Cab Booking Online, Online Cab Service Mumbai, Online Taxi Service Mumbai, Mumbai Airport Taxi Booking, Mumbai Outstation Cab Booking, Mumbai One Way Cab Booking, Mumbai Round Trip Taxi Booking, Instant Cab Booking Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onlinetaxibookingmumbai;